const a = require('../constants');

const defaultState = {
  client_api: undefined,
  client_server: undefined,
  payload: undefined,
  db_config: undefined,
  db_host_url: undefined,
  api_host_url: undefined,
  api_host_legacy_url: undefined,
  api_user_info: {
    tenant_id: 0,
    env_id: undefined,
  },
  device_id: undefined,
  isReady: false,
  connect_status: null
};

function assign(state, params) {
  return Object.assign({}, state, params);
}

const feathersClientReducer = function (state = defaultState, action) {
  const payload = action.payload;
  const type = action.type;
  switch (type) {
    case a.SET_FEATHERS_SERVER_CLIENT:
      return assign(state, { client_server: payload });

    case a.SET_FEATHERS_API_CLIENT:
      return assign(state, { client_api: payload });

    case a.SET_FEATHERS_PAYLOAD:
      const userInfo = {
        tenant_id: payload.tenant_id,
        env_id: payload.env_id,
      };
      return assign(state, { payload: payload, api_user_info: userInfo });

    case a.SET_DB_CONFIG:
      return assign(state, { db_config: payload });

    case a.SET_DB_URL:
      return assign(state, { db_host_url: payload });

    case a.SET_API_HOST_URL:
      return assign(state, { api_host_url: payload });

    case a.SET_API_HOST_LEGACY_URL:
      return assign(state, { api_host_legacy_url: payload });

    case a.SET_API_ACCESS_TOKEN:
      return assign(state, { api_access_token: payload });

    case 'APP_READY':
      return assign(state, { isReady: true});

    case 'API_NOT_ACCESSIBLE': 
      return assign(state, { notAccessible: true});

    case 'SERVER_RECONNECTING':
      return { ...state, connect_status: a.Status.RECONNECTING };

    case 'SERVER_DISCONNECTED':
      return { ...state, connect_status: a.Status.DISCONNECTED };

    case 'SERVER_CONNECTED':
      return { ...state, connect_status: a.Status.CONNECTED };
    
    default:
      return state;
  }
}

export default feathersClientReducer;